import PropTypes from 'prop-types';
import React from 'react';
import compose from '../../hoc/compose';
import { isRgbString, parseRgbString, applyOpacity, isHexString, hexToRgb, hexToRgbaCss, getLuminance } from '../../util/color';
import { generate as generateGradient, validate as isGradient } from '@wix/css-gradient-generator';
var NO_COLOR_LIST = ['transparent', 'noColor', ''];

function getTypeFromValue(value) {
  if (typeof value === 'string') {
    return 'color';
  }

  if (isGradient(value)) {
    return 'gradient';
  }
}

function getShadeByLuminance(value, opacity) {
  return getNormalizedLuminance(value, opacity / 100) > 0.5 ? 'light' : 'dark';
}

function getClassNameByProps(_ref) {
  var getClassName = _ref.getClassName,
      disabled = _ref.disabled,
      selected = _ref.selected,
      value = _ref.value,
      opacity = _ref.opacity;
  var classNames = [getTypeFromValue(value), getClassName('color-picker-input-ctrl'), disabled && 'disabled', selected && 'selected', getShadeByLuminance(value, opacity)];
  return classNames.filter(function (v) {
    return v;
  }).join(' ');
}

function getBackgroundFromProps(_ref2) {
  var value = _ref2.value,
      opacity = _ref2.opacity;

  if (value.includes('rgb') || NO_COLOR_LIST.includes(value)) {
    return value;
  }

  if (isHexString(value)) {
    return hexToRgbaCss(value, opacity / 100);
  }

  return '';
}

function tryGetRgbFromStringValue(value, opacity) {
  if (isRgbString(value)) {
    var _rgb$alpha;

    var rgb = parseRgbString(value);
    return applyOpacity(rgb, (_rgb$alpha = rgb.alpha) !== null && _rgb$alpha !== void 0 ? _rgb$alpha : 1);
  }

  if (isHexString(value)) {
    var _rgb = hexToRgb(value);

    return applyOpacity(_rgb, opacity);
  }

  return null;
}

function getNormalizedLuminance(value, opacity) {
  var rgb = typeof value === 'string' ? tryGetRgbFromStringValue(value, opacity) : null;
  return rgb ? getLuminance(rgb) : 1;
}

function getStyleByType(props) {
  var type = getTypeFromValue(props.value);
  var style = {};

  if (type === 'color') {
    style.backgroundColor = getBackgroundFromProps(props);
  } else if (type === 'gradient') {
    style.backgroundImage = generateGradient(props.value, {
      alpha: props.opacity / 100
    });
  }

  return style;
}

var ColorPickerInput = function ColorPickerInput(props) {
  return /*#__PURE__*/React.createElement('div', {
    className: 'color-picker-input-ctrl-wrapper'
  }, /*#__PURE__*/React.createElement('div', {
    onClick: props.disabled ? undefined : props.onClick,
    className: getClassNameByProps(props),
    style: getStyleByType(props),
    'data-aid': props.automationId,
    'data-hook': props.dataHook
  }, props.symbol ? /*#__PURE__*/React.createElement('div', {
    className: 'color-picker-input-symbol-wrapper'
  }, /*#__PURE__*/React.createElement(props.symbol)) : undefined));
};

ColorPickerInput.displayName = 'ColorPickerInput';
ColorPickerInput.propTypes = {
  /** Set the value of the ColorPickerInput. Values can be either:
   * - string: Represents a single color in HEX, RGB or RGBA
   * - Object: Represents a gradient corresponding to one of GradientLinear, GradientCircle or GradientConic data types
   * - Array of objects: Represents a list of gradients corresponding to any of GradientLinear, GradientCircle or GradientConic data types
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]),
  opacity: PropTypes.number,
  onClick: PropTypes.func,
  symbol: PropTypes.element
};
ColorPickerInput.defaultProps = {
  value: '#ffffff',
  opacity: 100
};
export default compose(ColorPickerInput);